import React, { useState, useEffect } from 'react';
import { object, bool, string, array } from 'prop-types';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { map, get, filter, size, groupBy, head, isEmpty, split, join, includes, forEach, flatten, values, times, toNumber } from 'lodash';
import { FlexContainer, Accordion, Text, Loading, If, NotFound } from '../../common';
import WindowCard from './WindowCard';
import { Query } from '../../graphql';
import GET_ORDERS_COUNTERS_BY_WINDOW from '../../../queries/GET_ORDERS_COUNTERS_BY_WINDOW';
import GET_LOG_WINDOWS_ASSIGN from '../../../queries/GET_LOG_WINDOWS_ASSIGN';
import Header from './Header';
import { withFirebase } from '../../../hoc';
import { getFilterSlaType } from '../../../utils/misc';
import moment from 'moment';

const Windows = ({ variablesWindow, isMobile, session, client, currentValue, selectedSalesChannels, selectedSalesChannelsStore, firebase, dateRange, isOnlyTodaySelected }) => {
    const [showResumeMobile, setShowResumeMobile] = useState(false);
    const [hoursAssignDispatch, setHoursAssignDispatch] = useState(0);
    const [windowLogs, setWindowLogs] = useState([]);

    useEffect(() => {
        const fetchWindowLogs = async () => {
            try {
                const response = await client.query({
                    query: GET_LOG_WINDOWS_ASSIGN,
                    variables: {
                        salesChannel: toNumber(head(selectedSalesChannels)),
                        init: `${dateRange[0].format('YYYY-MM-DD')} 00:00:00`,
                        end: `${dateRange[1].format('YYYY-MM-DD')} 23:59:59`
                    },
                    fetchPolicy: 'network-only',
                });
                setWindowLogs(get(response, 'data.getlogWindowsAssign.payload'));
            } catch (error) {
                console.error('Error fetching window logs:', error);
            }
        };

        fetchWindowLogs();

        const intervalId = setInterval(() => {
            fetchWindowLogs();
        }, 30000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        (async () => {
            await firebase.collection('salesChannel').doc(head(selectedSalesChannels)).onSnapshot(doc => setHoursAssignDispatch(get(doc.data(), 'hoursAssignDispatch', 0)));
        })();
    }, []);

    const slas = {
        'Despacho': ['domicio', 'especial'],
        'Retiro-en-Tienda': 'tienda',
        'Click-al-Auto': 'auto'
    };

    const isActiveAssignmentKind = (salesChannel) => {
        const getAllFieldsSelectedStore = head(filter(get(session, 'salesChannels', []), { id: salesChannel }));
        const assignAutoIsActive = get(getAllFieldsSelectedStore, 'assignment_kind') === '1';
        return assignAutoIsActive;
    };

    const getMaxHrsLimitWindow = () => {
        const getAllFieldsSelectedStore = head(filter(get(session, 'salesChannels', []), { id: head(selectedSalesChannelsStore) }));
        return get(getAllFieldsSelectedStore, 'max_hrs_limit_window', 0);
    };

    return (<Query
        query={GET_ORDERS_COUNTERS_BY_WINDOW}
        variables={variablesWindow}
        fetchPolicy='no-cache'
    >
        {({ data, networkStatus }) => {
            if (networkStatus === 1) { return <Loading loading /> }

            const windowsData = get(data, 'getOrdersCountersByWindow.data.bySalesChannel');
            const today = moment().format('YYYY-MM-DD');
            const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
            const selectedStartDate = dateRange[0].format('YYYY-MM-DD');
            const selectedEndDate = dateRange[1].format('YYYY-MM-DD');
            const rangeIncludesToday = moment(today).isBetween(selectedStartDate, selectedEndDate, 'day', '[]');

            let counters = {
                'Despacho': 0,
                'Retiro-en-Tienda': 0,
                'Click-al-Auto': 0
            };

            forEach(windowsData, element => {
                const index = get(element, 'info.selectedSla');
                const slaName = `${join(split(index, ' '), '-')}`;
                counters[slaName] = counters[slaName] + 1;
            });

            if (!size(windowsData)) {
                return <NotFound
                    firstTextLine='No se encontraron resultados'
                    icon='cross'
                    iconBackgroundColor='#eaeaea'
                />
            }

            const getWindowsWithoutTomorrow = () => {
                return filter(windowsData, ({ info }) => {
                    const windowDate = moment(info.init).format('YYYY-MM-DD');
                    return moment(windowDate).isBetween(selectedStartDate, selectedEndDate, 'day', '[]')
                });
            }

            const getWindowsExcludingToMorrowNonEarly = () => {
                return filter(windowsData, ({ info }) => {
                    const windowDate = moment(info.init).format('YYYY-MM-DD');

                    if (isOnlyTodaySelected) {
                        const isToday = windowDate === today;
                        const isEarlyDelivery = windowDate === tomorrow && get(info, 'category') === 'Anticipado';
                        return isToday || isEarlyDelivery;
                    }

                    return moment(windowDate).isBetween(selectedStartDate, selectedEndDate, 'day', '[]')
                });
            }
           
            return (<>
                <Header
                    store={getWindowsWithoutTomorrow()}
                    isMobile={isMobile}
                    showResumeMobile={showResumeMobile}
                    setShowResumeMobile={setShowResumeMobile}
                />
                <FlexContainer direction='column' paddingHorizontal={23}>
                    {map(slas, (value, index) => {
                        if (counters[index] <= 0) return null;

                        return (
                            <Accordion
                                title={<Text text={join(split(index, '-'), ' ')} size={14} semibold />}
                                defaultOpened
                                backgroundHeader='white'
                                background='F4F4F4'
                                fixedBackgroundHeader
                                iconOpened='chebron_down'
                                iconClosed='chebron_up'
                                iconPosition='left'
                                iconSize={10}
                                iconOpenedColor='#A4C735'
                                iconClosedColor='#A4C735'
                                style={{ marginTop: 10 }}
                            >
                                <FlexContainer
                                    key={index}
                                    style={isMobile
                                        ? { flexWrap: 'nowrap', overflowX: 'scroll' }
                                        : { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 10, marginTop: 10 }}
                                >
                                    {map(getWindowsExcludingToMorrowNonEarly(), (card, index) => {
                                        const filterSelectedSla = getFilterSlaType(get(card, 'info.selectedSla'));

                                        if (isEmpty(filter(filterSelectedSla, e => includes(value, e)))) return null;

                                        const isDeliveryTomorrow = moment(get(card, 'info.init')).isSame(tomorrow, 'day') && rangeIncludesToday
                                        const isEarlyDelivery = get(card, 'info.category') === 'Anticipado'

                                        return (
                                            <WindowCard
                                                isDeliveryTomorrow={isDeliveryTomorrow}
                                                isEarlyDelivery={isEarlyDelivery}
                                                windowLogs={windowLogs}
                                                isMobile={isMobile}
                                                card={card}
                                                key={index}
                                                label={get([], 'label', '')}
                                                color='#CC444B'
                                                selectedSalesChannels={selectedSalesChannels}
                                                width={currentValue}
                                                assignmentKind={isActiveAssignmentKind(get(card, 'info.salesChannel'))}
                                                maxHrsLimitWindow={getMaxHrsLimitWindow()}
                                                hoursAssignDispatch={hoursAssignDispatch}
                                                userId={get(session, 'email')}
                                            />
                                        );
                                    })}
                                </FlexContainer>
                            </Accordion>
                        );
                    })}
                </FlexContainer>
            </>)
        }}
    </Query>);
};

Windows.propTypes = {
    variablesWindow: object,
    isMobile: bool,
    client: object,
    session: object,
    selectedSalesChannels: array,
    selectedSalesChannelsStore: array,
    firebase: object,
    dateRange: array,
    WindowCard: array,
    isOnlyTodaySelected: bool
};

export default withRouter(withFirebase(withApollo(Windows)));